/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type TestJoinConfigQueryVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  baseDataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
  baseColumnName: Types.Scalars["String"]["input"];
  targetDataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
  targetColumnName: Types.Scalars["String"]["input"];
}>;

export type TestJoinConfigQuery = {
  readonly __typename: "Query";
  readonly testJoin: {
    readonly __typename: "JoinTestResult";
    readonly dbError: string | null;
    readonly hadValidationTimeout: boolean;
    readonly hasFanout: boolean;
    readonly hasNoMatches: boolean;
  };
};

export type TestUniqueKeyConfigQueryVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  dataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
  columnName: Types.Scalars["String"]["input"];
}>;

export type TestUniqueKeyConfigQuery = {
  readonly __typename: "Query";
  readonly testUniqueKey: {
    readonly __typename: "UniqueKeyTestResult";
    readonly dbError: string | null;
    readonly keyNotUnique: boolean;
  };
};

export const TestJoinConfigDocument = /*#__PURE__*/ gql`
  query TestJoinConfig(
    $dataConnectionId: DataConnectionId!
    $baseDataSourceTableId: DataSourceTableId!
    $baseColumnName: String!
    $targetDataSourceTableId: DataSourceTableId!
    $targetColumnName: String!
  ) {
    testJoin(
      dataConnectionId: $dataConnectionId
      baseDataSourceTableId: $baseDataSourceTableId
      baseColumnName: $baseColumnName
      targetDataSourceTableId: $targetDataSourceTableId
      targetColumnName: $targetColumnName
    ) {
      dbError
      hadValidationTimeout
      hasFanout
      hasNoMatches
    }
  }
`;

/**
 * __useTestJoinConfigQuery__
 *
 * To run a query within a React component, call `useTestJoinConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestJoinConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestJoinConfigQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      baseDataSourceTableId: // value for 'baseDataSourceTableId'
 *      baseColumnName: // value for 'baseColumnName'
 *      targetDataSourceTableId: // value for 'targetDataSourceTableId'
 *      targetColumnName: // value for 'targetColumnName'
 *   },
 * });
 */
export function useTestJoinConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    TestJoinConfigQuery,
    TestJoinConfigQueryVariables
  > &
    (
      | { variables: TestJoinConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestJoinConfigQuery, TestJoinConfigQueryVariables>(
    TestJoinConfigDocument,
    options,
  );
}
export function useTestJoinConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TestJoinConfigQuery,
    TestJoinConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestJoinConfigQuery, TestJoinConfigQueryVariables>(
    TestJoinConfigDocument,
    options,
  );
}
// @ts-ignore
export function useTestJoinConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TestJoinConfigQuery,
    TestJoinConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TestJoinConfigQuery,
  TestJoinConfigQueryVariables
>;
export function useTestJoinConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestJoinConfigQuery,
        TestJoinConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TestJoinConfigQuery | undefined,
  TestJoinConfigQueryVariables
>;
export function useTestJoinConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestJoinConfigQuery,
        TestJoinConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TestJoinConfigQuery,
    TestJoinConfigQueryVariables
  >(TestJoinConfigDocument, options);
}
export type TestJoinConfigQueryHookResult = ReturnType<
  typeof useTestJoinConfigQuery
>;
export type TestJoinConfigLazyQueryHookResult = ReturnType<
  typeof useTestJoinConfigLazyQuery
>;
export type TestJoinConfigSuspenseQueryHookResult = ReturnType<
  typeof useTestJoinConfigSuspenseQuery
>;
export type TestJoinConfigQueryResult = Apollo.QueryResult<
  TestJoinConfigQuery,
  TestJoinConfigQueryVariables
>;
export const TestUniqueKeyConfigDocument = /*#__PURE__*/ gql`
  query TestUniqueKeyConfig(
    $dataConnectionId: DataConnectionId!
    $dataSourceTableId: DataSourceTableId!
    $columnName: String!
  ) {
    testUniqueKey(
      dataConnectionId: $dataConnectionId
      dataSourceTableId: $dataSourceTableId
      columnName: $columnName
    ) {
      dbError
      keyNotUnique
    }
  }
`;

/**
 * __useTestUniqueKeyConfigQuery__
 *
 * To run a query within a React component, call `useTestUniqueKeyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestUniqueKeyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestUniqueKeyConfigQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      dataSourceTableId: // value for 'dataSourceTableId'
 *      columnName: // value for 'columnName'
 *   },
 * });
 */
export function useTestUniqueKeyConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    TestUniqueKeyConfigQuery,
    TestUniqueKeyConfigQueryVariables
  > &
    (
      | { variables: TestUniqueKeyConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TestUniqueKeyConfigQuery,
    TestUniqueKeyConfigQueryVariables
  >(TestUniqueKeyConfigDocument, options);
}
export function useTestUniqueKeyConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TestUniqueKeyConfigQuery,
    TestUniqueKeyConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TestUniqueKeyConfigQuery,
    TestUniqueKeyConfigQueryVariables
  >(TestUniqueKeyConfigDocument, options);
}
// @ts-ignore
export function useTestUniqueKeyConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TestUniqueKeyConfigQuery,
    TestUniqueKeyConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TestUniqueKeyConfigQuery,
  TestUniqueKeyConfigQueryVariables
>;
export function useTestUniqueKeyConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestUniqueKeyConfigQuery,
        TestUniqueKeyConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TestUniqueKeyConfigQuery | undefined,
  TestUniqueKeyConfigQueryVariables
>;
export function useTestUniqueKeyConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TestUniqueKeyConfigQuery,
        TestUniqueKeyConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TestUniqueKeyConfigQuery,
    TestUniqueKeyConfigQueryVariables
  >(TestUniqueKeyConfigDocument, options);
}
export type TestUniqueKeyConfigQueryHookResult = ReturnType<
  typeof useTestUniqueKeyConfigQuery
>;
export type TestUniqueKeyConfigLazyQueryHookResult = ReturnType<
  typeof useTestUniqueKeyConfigLazyQuery
>;
export type TestUniqueKeyConfigSuspenseQueryHookResult = ReturnType<
  typeof useTestUniqueKeyConfigSuspenseQuery
>;
export type TestUniqueKeyConfigQueryResult = Apollo.QueryResult<
  TestUniqueKeyConfigQuery,
  TestUniqueKeyConfigQueryVariables
>;
